export const isBrowsingAsUser = () => Boolean(sessionStorage.altCrmId)

export const isDpReadOnlyAdmin = () =>
  localStorage.isDpReadOnlyAdmin === 'true' && localStorage.isDpAdmin !== 'true'

export const isReadOnlyAdminBrowsingAsUser = () =>
  isBrowsingAsUser() && isDpReadOnlyAdmin()
